import axios from 'axios';
import { API_URL, getAuthHeader } from '.';
import { ResponseModel } from '../Models/ResponseModel';
import { Vendor } from '../Models/Vendor';
import { Inventory } from '../Models/Inventory';

class VendorApi {
  static getVendor(id: string) {
    return axios.get<Vendor>(`${API_URL}/api/vendor/${id}`, getAuthHeader());
  }
  static addUpdateVendor(request: Vendor) {
    return axios.post<ResponseModel>(
      `${API_URL}/api/vendor`,
      request,
      getAuthHeader()
    );
  }
  static getVendorsList() {
    return axios.get<Vendor[]>(`${API_URL}/api/vendor`);
  }
  static deleteVendorLocation(id: number) {
    return axios.delete<ResponseModel>(
      `${API_URL}/api/vendor/${id}`,
      getAuthHeader()
    );
  }
  static getInventoryForVendor(id: number) {
    return axios.get<Inventory[]>(
      `${API_URL}/api/vendor/inventory/${id}`,
      getAuthHeader()
    );
  }
  static deleteInventory(id: number) {
    return axios.delete<ResponseModel>(
      `${API_URL}/api/vendor/inventory/${id}`,
      getAuthHeader()
    );
  }
  static addUpdateInventory(request: Inventory) {
    return axios.post<ResponseModel>(
      `${API_URL}/api/vendor/inventory`,
      request,
      getAuthHeader()
    );
  }
}

export default VendorApi;
